import React from 'react'
import {
    Card, Button, CardTitle, Alert,
    Collapse, Row, Col
} from 'reactstrap'
import { Pribadi, Ayah, Ibu, Wali, Pendukung } from './details'
import { cookies, cookieName } from '../../../../global'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { cmahasiswa } from '../../../../actions'
import swal from 'sweetalert';

class Verifikasi extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            collapsePribadi: false,
            collapseAyah: false,
            collapseIbu: false,
            collapseWali: false,
            collapseSurat: false,
            checked: false,
        }

        this.toggle = this.toggle.bind(this)
    }
    UNSAFE_componentWillMount() {
        this.props.dispatch(cmahasiswa.getByLoggedIn(cookies.get(cookieName)))
    }
    toggle = (stateName, val) => {
        var obj = { [stateName]: val }
        for (var key in this.state) {
            if (key !== stateName) obj[key] = false
        }
        this.setState(obj)
    }
    verify = () => {
        this.props.dispatch(cmahasiswa.tinggiSelesai(cookies.get(cookieName)))
    }
    renderSection = (title, icon, stateName, Component) => (
        <div className="mb-3 border rounded-xl overflow-hidden shadow-sm bg-white">
            <div 
                className="d-flex align-items-center justify-content-between p-3 cursor-pointer hover-bg-light"
                onClick={() => this.toggle(stateName, !this.state[stateName])}
                style={{ cursor: 'pointer', background: this.state[stateName] ? '#f8fafc' : '#fff' }}
            >
                <div className="font-weight-bold text-dark text-sm sm:text-base">
                    <i className={`fa ${icon} mr-3 text-emerald`}></i> {title}
                </div>
                <i className={`fa ${this.state[stateName] ? 'fa-chevron-up' : 'fa-chevron-down'} text-muted`}></i>
            </div>
            <Collapse isOpen={this.state[stateName]}>
                <div className="p-3 p-sm-4 p-md-5 border-top bg-white">
                    <Component />
                </div>
            </Collapse>
        </div>
    )

    render() {
        if (this.props.cmahasiswa.flag === "selesai_isi") {
            return <Redirect to="/main/ukt/selesai-isi" />
        }
        return (
            <Card className="premium-card p-3 p-sm-4 p-md-5">
                <CardTitle tag="h4" className="mb-4 font-weight-bold text-lg sm:text-xl md:text-2xl">
                    Verifikasi & Finalisasi Data
                </CardTitle>
                
                { (this.props.allow === undefined || this.props.allow === 0) && (
                    <Alert color="warning" className="rounded-xl shadow-sm border-0 mb-4 px-3 py-3 d-flex align-items-start">
                        <i className="fa fa-info-circle mr-3 mt-1 text-lg"></i> 
                        <span className="text-sm sm:text-base">
                            Verifikasi dapat dilakukan setelah <strong>seluruh tahapan data</strong> terisi lengkap.
                        </span>
                    </Alert>
                )}

                { (this.props.allow !== undefined && this.props.allow !== 0) && (
                    <div>
                        <div className="my-4">
                            <h5 className="mb-4 font-weight-bold text-secondary border-bottom pb-2 text-base sm:text-lg">
                                <i className="fa fa-search mr-2"></i> Pratinjau Seluruh Data:
                            </h5>
                            {this.renderSection('Data Pribadi', 'fa-user', 'collapsePribadi', Pribadi)}
                            {this.renderSection('Data Ayah', 'fa-user', 'collapseAyah', Ayah)}
                            {this.renderSection('Data Ibu', 'fa-user', 'collapseIbu', Ibu)}
                            {this.renderSection('Data Wali', 'fa-users', 'collapseWali', Wali)}
                            {this.renderSection('Surat Pernyataan', 'fa-file-text', 'collapseSurat', Pendukung)}
                        </div>

                        <div className="mt-5 pt-4 border-top">
                            <Alert color="danger" className="rounded-xl border-0 shadow-sm mb-4">
                                <div className="d-flex align-items-start">
                                    <i className="fa fa-exclamation-triangle mr-3 mt-1 text-lg d-none d-sm-block"></i>
                                    <div className="text-xs sm:text-sm">
                                        <strong>Perhatian!</strong> Pastikan seluruh data di atas sudah benar. Setelah finalisasi, data <strong>tidak dapat diubah kembali</strong>.
                                    </div>
                                </div>
                            </Alert>

                            <div className="custom-control custom-checkbox my-4 p-3 rounded bg-light" style={{border: '1px dashed #ccc'}}>
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="checkSetujuTinggi"
                                    onChange={(e) => this.setState({ checked: e.target.checked })}
                                />
                                <label className="custom-control-label font-weight-bold text-dark cursor-pointer" htmlFor="checkSetujuTinggi" style={{fontSize: '0.95rem'}}>
                                    Saya menyatakan bahwa seluruh data yang saya isi adalah <strong>BENAR dan JUJUR</strong>.
                                </label>
                            </div>

                            <Row className="align-items-center">
                                <Col lg="8" md="7" xs="12"></Col>
                                <Col lg="4" md="5" xs="12">
                                    <Button 
                                        className="modern-btn-primary w-100 py-3 shadow font-weight-bold"
                                        onClick={async () => {
                                            const confirmSelesai = await swal({
                                                title: "Konfirmasi Selesai?",
                                                text: "Pastikan semua data sudah diperiksa. Setelah dikonfirmasi, Anda tidak dapat mengubah data ini lagi.",
                                                icon: "info",
                                                buttons: ["Batal", "Ya, Konfirmasi"],
                                            });

                                            if (confirmSelesai) {
                                                // Memanggil fungsi verify yang sudah di-bind secara otomatis oleh arrow function
                                                this.verify(); 
                                            }
                                        }}
                                        disabled={!this.state.checked}
                                    >
                                        <i className="fa fa-check-circle mr-2"></i> Finalisasi Data
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                )}
            </Card>
        )
    }
}

export default connect(
    (store) => ({
        cmahasiswa: store.cmahasiswa.cmahasiswa
    })
)(Verifikasi)